export const MIN_DIMENSION = 0.01
